package org.zq.astrock_ai.api

/**
 * 行情图周期。
 * EastMoney klt：1=1分, 101=日, 102=周, 103=月；分时/五日走 trends2。
 */
enum class ChartPeriod(
    val apiValue: String,
    val label: String,
    val chartType: String,
    val defaultLimit: Int,
) {
    INTRADAY("intraday", "分时", "line", 240),
    FIVE_DAY("five_day", "五日", "line", 1200),
    DAY("day", "日K", "candle", 120),
    WEEK("week", "周K", "candle", 120),
    MONTH("month", "月K", "candle", 120);

    val isLineChart: Boolean get() = chartType == "line"

    companion object {
        fun fromApi(value: String?): ChartPeriod =
            entries.find { it.apiValue.equals(value, ignoreCase = true) }
                ?: entries.find { it.label == value }
                ?: DAY
    }
}
